<template>
  <div class="mb-4">
    <h2 class="text-lg font-semibold mb-2">Types</h2>
    <div class="flex flex-wrap gap-2">
      <Badge
        v-if="primaryType"
        variant="secondary"
        class="text-sm font-medium px-3 py-1 rounded-full"
        :style="getTypeStyle(primaryType)"
      >
        {{ formatType(primaryType) }}
      </Badge>
      <Badge
        v-for="type in filteredTypes"
        :key="type"
        variant="outline"
        class="text-sm font-medium px-3 py-1 rounded-full"
        :style="getTypeStyle(type)"
      >
        {{ formatType(type) }}
      </Badge>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Badge } from '@/components/ui/badge'

const props = defineProps<{
  primaryType?: string
  types: string[]
}>()

const filteredTypes = computed(() => {
  return props.types.filter((type) => type !== props.primaryType)
})

const typeColors: { [key: string]: string } = {
  restaurant: '#FF6B6B',
  bar: '#4ECDC4',
  cafe: '#45B7D1',
  pub: '#FFA07A',
  fast_food: '#FFD700',
  fine_dining: '#9370DB',
  bakery: '#F08080',
  dessert: '#FF69B4',
  nightclub: '#8A2BE2',
  lounge: '#20B2AA',
  winery: '#800080',
  brewery: '#DAA520',
  food_truck: '#32CD32',
  deli: '#FF7F50',
  steakhouse: '#8B4513',
  seafood: '#4682B4',
  sushi: '#FA8072',
  italian: '#006400',
  mexican: '#FF4500',
  chinese: '#DC143C',
  japanese: '#FF1493',
  indian: '#FFA500',
  thai: '#9ACD32',
  greek: '#4169E1',
  french: '#1E90FF',
  american: '#B22222',
}

const getTypeStyle = (type: string) => {
  const color = typeColors[type.toLowerCase()] || '#6B7280' // Default color if not found
  return {
    backgroundColor: `${color}20`,
    color: color,
    borderColor: color,
  }
}

const formatType = (type: string) => {
  return type
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
</script>
